import React from 'react';

/** Subtle glitch on hover. Keeps the original readable text underneath. */
export default function GlitchText({ text, className = '', as: Tag = 'span' }) {
  return (
    <Tag className={`group/glitch relative inline-block ${className}`}>
      <span className={`relative z-10 ${className}`}>{text}</span>
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute inset-0 z-0 text-cyan-400 opacity-0
                    mix-blend-screen group-hover/glitch:animate-glitch group-hover/glitch:opacity-70`}
      >
        {text}
      </span>
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute inset-0 z-0 text-rose-400 opacity-0
                    mix-blend-screen group-hover/glitch:animate-glitch group-hover/glitch:opacity-50`}
        style={{ animationDelay: '0.08s' }}
      >
        {text}
      </span>
    </Tag>
  );
}
